<template>
    <section class="confirmation" id="confirmation">
        <div v-if="vehicleAdded" class="confirmation__hero-container">
            <div class="confirmation__bg" :class="brand"></div>
        </div>
        <template v-if="displayCreateAccount === true">
            <div class="container confirmation__container">
                <div>
                    <h3 class="title confirmation__main-heading">Your booking request confirmation</h3>
                    <p class="confirmation__text">
                        A confirmation email has been sent to you and a customer advisor will be in contact to confirm your booking request date and drop off time. 
                        <br />
                        <br />
                        If you have any questions before your appointment you can contact us via our contact us page or by telephoning 024 7685 1406.
                        <br />
                        <br />
                        Great experiences start with mutual respect and kindness. We look forward to seeing you soon.
                    </p>
                    <div class="confirmation__booking-overview-mobile">
                        <BookingOverview />
                    </div>
                    
                    <div class="card confirmation__card">
                        <div class="card__inner">
                            <h3 class="card__heading confirmation__card-heading">Booking Details</h3>
                            <p class="card__text"><strong>Date:</strong> {{ formattedDate }}</p>
                            <p class="card__text"><strong>Time:</strong> {{ selectedTime }}</p>
                            <div class="confirmation__card-flex">
                                <div>
                                    <h3 class="confirmation__dealer-information-heading">Dealer Address</h3>
                                    <p class="card__text">
                                        {{ selectedDealer.used_name }} <br />
                                        {{ selectedDealer.address }}, <br />
                                        {{ selectedDealer.town }}, <br />
                                        {{ selectedDealer.postcode }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="confirmation__create-account">
                    <div class="confirmation__create-account">
                        <div class="confirmation__create-account--bg">
                            <img src="/images/my-account/my-account-icon.svg" alt="" class="confirmation__create-account--logo" />
                        </div>
                        <div class="login__form-item-osb confirmation__create-account--form" style="position: relative">
                            <h3 class="confirmation__create-account--heading">Would you like to create an account?</h3>
                            <p class="confirmation__create-account--text">
                                In just a few clicks create your Stellantis &You UK account
                            </p>
                            <create-password :registration="this.selectedVehicle.registration" :mileage="this.selectedVehicle.mileage" :locationId="this.selectedDealer.id" />
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="container">
                <div v-if="! shortOnlineServiceBooking" class="confirmation__alert confirmation__alert--success">
                    This vehicle has been added to your account.
                </div>
            </div>
            <div class="container confirmation__container">
                <div>
                    <h3 class="title confirmation__main-heading">Your booking request confirmation</h3>
                    <p class="confirmation__text">
                        A confirmation email has been sent to you and a customer advisor will be in contact to confirm your booking request date and drop off time.
                        <br />
                        <br />
                        If you have any questions before your appointment you can contact us via our contact us page or by telephoning 024 7685 1406.
                        <br/>
                        <br />
                        Great experiences start with mutual respect and kindness. We look forward to seeing you soon.
                    </p>
                    <div class="confirmation__booking-overview-mobile">
                        <BookingOverview />
                    </div>
                    <div class="card confirmation__card">
                        <div class="card__inner">
                            <h3 class="card__heading confirmation__card-heading">Booking Details</h3>
                            <p class="card__text"><strong>Date:</strong> {{ formattedDate }}</p>
                            <p class="card__text"><strong>Time:</strong> {{ selectedTime }}</p>
                            <div class="confirmation__card-flex">
                                <div>
                                    <h3 class="confirmation__dealer-information-heading">Dealer Address</h3>
                                    <p class="card__text">
                                        {{ selectedDealer.used_name }} <br />
                                        {{ selectedDealer.address }}, <br />
                                        {{ selectedDealer.town }}, <br />
                                        {{ selectedDealer.postcode }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="confirmation__booking-overview-desktop">
                    <BookingOverview />
                </div>
            </div>
        </template>
    </section>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import BookingOverview from '../BookingOverview'
import CreatePassword from "../../../core/components/Forms/CreatePassword.vue";
import Email from "../../../core/components/Forms/Email.vue";

export default {
    components: {
        BookingOverview,
        CreatePassword,
        Email
    },
    methods: {
        register() {

        }
    },
    computed: {
        ...mapState('OSB', ['selectedTime', 'selectedDate', 'brand', 'selectedVehicle', 'nonFranchiseVehicle', 'carNotFound', 'step', 'shortOnlineServiceBooking']),
        ...mapState("Auth", ['authenticated', 'hasAccount', 'vehicleAdded']),
        ...mapState('Dealers', ['selectedDealer']),
        ...mapGetters('CustomerData', ['customerData']),

        displayCreateAccount() {
            if (this.hasAccount === true) {
                return false
            }
            if (this.authenticated === true) {
                return false
            }
            return true
        },

        directionsLink() {
            return this.selectedDealer.address
                ? `https://www.google.com/maps?daddr=${this.selectedDealer.address}+${this.selectedDealer.town}+${this.selectedDealer.postcode}`
                : '#';
        },

        formattedDate() {
            return this.selectedDate
                ? new Date(this.selectedDate).toDateString()
                : '';
        },

    },
    mounted() {
        if (this.hasAccount === true) {
            const userName = this.customerData.firstName;
            const myAccountSpan = document.getElementById('header-menu__my-account');
            if (myAccountSpan) {
                myAccountSpan.textContent = userName;
            }
        }
    },

}
</script>